import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import CheckBox from '../../../../components/Checkbox';

export default function ContentFilter({ settings, getSettingsFilteredData, startDate, endDate }) {
  const [contentFilterCheckboxValues, setContentFilterCheckboxValues] = useState({});
  const filterRef = useRef(null);
  const isFirstRenderRef = useRef(true);

  useEffect(() => {
    if (settings.WorkkardNotes && settings.WorkkardLogs && settings.WorkkardActions && settings.ActivityNotes && settings.ActivityLogs && settings.ActivityActions) {
      setContentFilterCheckboxValues({
        WorkkardNotes: false,
        ActivityNotes: false,
        WorkkardLogs: false,
        ActivityLogs: false,
        WorkkardActions: false,
        ActivityActions: false,
        WorkkardFiles: false,
        ActivityFiles: false
      });
    } else {
      setContentFilterCheckboxValues({
        WorkkardNotes: settings.WorkkardNotes,
        ActivityNotes: settings.ActivityNotes,
        WorkkardLogs: settings.WorkkardLogs,
        ActivityLogs: settings.ActivityLogs,
        WorkkardActions: settings.WorkkardActions,
        ActivityActions: settings.ActivityActions,
        WorkkardFiles: settings.WorkkardFiles,
        ActivityFiles: settings.ActivityFiles
      });
    }
  }, []);

  useEffect(() => {
    if (isFirstRenderRef.current) {
      isFirstRenderRef.current = false;
      return;
    }
    if (settings.WorkkardNotes && settings.WorkkardLogs && settings.WorkkardActions && settings.WorkkardFiles && settings.ActivityNotes && settings.ActivityLogs && settings.ActivityActions && settings.ActivityFiles) {
      setContentFilterCheckboxValues({
        WorkkardNotes: false,
        ActivityNotes: false,
        WorkkardLogs: false,
        ActivityLogs: false,
        WorkkardActions: false,
        ActivityActions: false,
        WorkkardFiles: false,
        ActivityFiles: false
      });
    } else {
      setContentFilterCheckboxValues({
        WorkkardNotes: settings.WorkkardNotes,
        ActivityNotes: settings.ActivityNotes,
        WorkkardLogs: settings.WorkkardLogs,
        ActivityLogs: settings.ActivityLogs,
        WorkkardActions: settings.WorkkardActions,
        ActivityActions: settings.ActivityActions,
        WorkkardFiles: settings.WorkkardFiles,
        ActivityFiles: settings.ActivityFiles
      });
    }
  }, [settings]);

  function handleCheckboxFilterChange(e) {
    const newValues = {
      WorkkardNotes: (e.value == "WorkkardNotes") ? !contentFilterCheckboxValues.WorkkardNotes : contentFilterCheckboxValues.WorkkardNotes,
      ActivityNotes: (e.value == "ActivityNotes") ? !contentFilterCheckboxValues.ActivityNotes : contentFilterCheckboxValues.ActivityNotes,
      WorkkardLogs: (e.value == "WorkkardLogs") ? !contentFilterCheckboxValues.WorkkardLogs : contentFilterCheckboxValues.WorkkardLogs,
      ActivityLogs: (e.value == "ActivityLogs") ? !contentFilterCheckboxValues.ActivityLogs : contentFilterCheckboxValues.ActivityLogs,
      WorkkardActions: (e.value == "WorkkardActions") ? !contentFilterCheckboxValues.WorkkardActions : contentFilterCheckboxValues.WorkkardActions,
      ActivityActions: (e.value == "ActivityActions") ? !contentFilterCheckboxValues.ActivityActions : contentFilterCheckboxValues.ActivityActions,
      WorkkardFiles: (e.value == "WorkkardFiles") ? !contentFilterCheckboxValues.WorkkardFiles : contentFilterCheckboxValues.WorkkardFiles,
      ActivityFiles: (e.value == "ActivityFiles") ? !contentFilterCheckboxValues.ActivityFiles : contentFilterCheckboxValues.ActivityFiles
    };
    setContentFilterCheckboxValues(newValues);
    const settingsValue = Object.values(newValues);
    const arr = settingsValue.filter(item => item == false);
    let settingsPayload = {};
    if (arr.length == Object.keys(settingsValue).length) {
      settingsPayload = {
        ActivityNotes: true,
        ActivityLogs: true,
        ActivityActions: true,
        ActivityFiles: true,
        WorkkardNotes: true,
        WorkkardLogs: true,
        WorkkardActions: true,
        WorkkardFiles: true,
      }
    } else {
      settingsPayload = newValues;
    }
    const payload = { settings: Object.assign({}, { IsSortedAscending: settings.IsSortedAscending }, settingsPayload), sdate: startDate ? startDate.split(',')[0] : '', edate: endDate ? endDate.split(',')[0] : '', start: 0, end: 50 }
    getSettingsFilteredData(payload);
  }

  function renderLI(val) {
    return (
      <ul className="rowFlex rowSpaceBetween alignMiddle">
        <li><span>{val}</span></li>
        {renderCheckboxs(`Workkard${val}`)}
        {renderCheckboxs(`Activity${val}`)}
      </ul>
    );
  }

  function renderCheckboxs(value) {
    return (
      <li className="cetner">
        <div className="checkboxArea">
          <CheckBox item={{
            id: value,
            value,
            checked: contentFilterCheckboxValues[value]
          }}
            handleCheckbox={(e) => handleCheckboxFilterChange(e)} />
        </div>
      </li>
    );
  }

  return (
    <div ref={filterRef}>
      <ul className="tHead rowFlex rowSpaceBetween">
        <li>&nbsp;</li>
        <li className="cetner">Workkard</li>
        <li className="cetner">Activity </li>
      </ul>
      {renderLI('Notes')}
      {renderLI('Logs')}
      {renderLI('Actions')}
      {renderLI('Files')}
    </div>
  )
}

